"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBSearchNegative = function SvgBSearchNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M55.238 95.238c-18.423.04-34.48-12.535-38.857-30.43a2.287 2.287 0 114.442-1.09C25.092 81.13 41.692 92.61 59.489 90.46c17.798-2.15 31.187-17.253 31.187-35.18S77.287 22.25 59.489 20.1c-17.797-2.15-34.397 9.33-38.666 26.742a2.286 2.286 0 11-4.442-1.082c4.935-20.277 24.625-33.357 45.23-30.045 20.605 3.311 35.205 21.902 33.538 42.704-1.667 20.803-19.042 36.831-39.91 36.82z"
  }), (0, _core.jsx)("path", {
    d: "M55.246 109.775C29.24 109.8 6.835 91.46 1.72 65.962c-5.114-25.497 8.487-51.059 32.49-61.064C58.217-5.106 85.946 3.23 100.454 24.811c14.51 21.582 11.762 50.406-6.563 68.858l-.336.327 5.189 5.189a2.286 2.286 0 11-3.23 3.23l-6.858-6.819a2.286 2.286 0 010-3.238l.869-.838a61.121 61.121 0 011.105-1.082c18.301-18.448 19.376-47.856 2.47-67.592C76.194 3.111 46.97-.342 25.93 14.91 4.89 30.161-.92 59.01 12.578 81.215c13.497 22.206 41.78 30.333 65.007 18.678a2.286 2.286 0 012.042 4.092 54.416 54.416 0 01-24.381 5.79z"
  }), (0, _core.jsx)("path", {
    d: "M40.853 36.32a2.286 2.286 0 01-1.287-4.175 27.84 27.84 0 014.236-2.37 2.287 2.287 0 111.867 4.175 22.98 22.98 0 00-3.536 1.974 2.286 2.286 0 01-1.28.396zM31.238 66.53a2.286 2.286 0 01-2.14-1.486 27.855 27.855 0 011.76-23.383 2.286 2.286 0 013.992 2.225 23.291 23.291 0 00-1.479 19.55A2.286 2.286 0 0132 66.385a2.43 2.43 0 01-.762.145zM128.312 143.429a11.261 11.261 0 01-7.992-3.3l-29.265-29.272a2.286 2.286 0 010-3.23l12.755-12.755a2.286 2.286 0 013.23 0l6.804 6.804a2.287 2.287 0 01-3.238 3.23l-5.181-5.18-9.524 9.516 27.65 27.65a6.735 6.735 0 0011.497-4.762 6.66 6.66 0 00-1.974-4.755l-14.057-14.057a2.29 2.29 0 113.238-3.238l14.05 14.057a11.299 11.299 0 01-7.993 19.292z"
  }), (0, _core.jsx)("path", {
    d: "M107.878 111.505a2.286 2.286 0 01-1.615-3.901l5.135-5.135a2.287 2.287 0 013.238 3.23l-5.143 5.135c-.428.43-1.009.67-1.615.67z"
  })));
};

var _default = SvgBSearchNegative;
exports["default"] = _default;